export const SET_DARK_THEME = 'SET_DARK_THEME'
export const TOGGLE_ACCOUNT_MODAL = 'TOGGLE_ACCOUNT_MODAL'
export const SORT = 'SORT'
export const FILTER = 'FILTER'
export const SET_PAGE = 'SET_PAGE'
export const SET_ROW_PAGE = 'SET_ROW_PAGE'
export const SET_DOCUMENTS = 'SET_DOCUMENTS'

export const ON_ERROR = 'ON_ERROR'